import { Component, input } from '@angular/core';
import { Aufgabe } from '@schir-int-client/aufgabe-shared';

@Component({
	selector: 'schir-int-client-aufgabe-heimatverlegung',
	templateUrl: './aufgabe-heimatverlegung-body.component.html',
})
export class AufgabeHeimatverlegungBodyComponent {
	readonly aufgabe = input.required<Aufgabe>();
}
